import { render } from "./AppLoadingSkeleton.vue?vue&type=template&id=4afc02f5"
import script from "./AppLoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./AppLoadingSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__